import React, { useState, useEffect } from 'react';
import { mergeClasses } from '@griffel/react';

const UIIconToggle = ({ className, iconClass, value, onChange }) => 
{
	const [isOn, setIsOn] = useState(value);

	useEffect(() => 
	{
		setIsOn(value);
	},
	[value]);

	const handleClick = () => 
	{
		const newState = !isOn;
		setIsOn(newState);
		onChange(newState);
	};

	return (
		<div className={mergeClasses('ui-icon-toggle', className)} onClick={handleClick} data-checked={isOn ? 1 : 0}>
			<p className={mergeClasses('icon', iconClass)} />
			<span className="toggle-label">{isOn ? 'ON' : 'OFF'}</span>
		</div>
	);
};

export default UIIconToggle;
